import React from 'react';

import { useRouter } from 'expo-router';

import { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { routes } from 'navigation/routing';
import { selectors, useAppSelector } from 'state/global-state';
import { t } from 'state/intl/translations';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'state/launchdarkly/flags';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { theme } from 'styles/configure-theme';

import { StyledLoyaltyButton, StyledLoyaltyPointsIcon } from './styled';
import componentTheme from './theme';

export const LoyaltyPointsButton = ({ reversed = false }: { reversed?: boolean }) => {
  const enableLoyaltyPointsInHeader = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_POINTS_IN_HEADER);
  const router = useRouter();

  const loyaltyEnabled = useIsLoyaltyEnabled();
  const { loyaltyUser } = useLoyaltyUser();
  const availablePoints = useAppSelector(selectors.loyalty.selectStagedCartPoints);

  const showLoyaltyCta = Boolean(enableLoyaltyPointsInHeader && loyaltyEnabled && loyaltyUser);

  const handleOnPress = () => {
    router.navigate(routes.rewards);
  };

  if (!showLoyaltyCta) {
    return null;
  }

  return (
    <StyledLoyaltyButton
      variant={ActionButtonVariants.OUTLINE}
      size={ActionButtonSizes.SMALL}
      testID="app-header-loyalty-cta"
      onPress={handleOnPress}
      reversed={reversed}
      endIcon={
        <StyledLoyaltyPointsIcon
          reversed={reversed}
          color={reversed ? theme.token('crown-color') : undefined}
        />
      }
      accessibilityLabel={`${String(availablePoints)} ${t(componentTheme.points)}`}
    >
      {String(availablePoints)}
    </StyledLoyaltyButton>
  );
};
